import { call, put, takeLatest } from "redux-saga/effects";
import { apiWrapper } from "../../../api/apiWrapper";
import { IHocSinhSelectRequest } from "../../../models/request/hoc-sinh/IHocSinhSelectRequest";
import { IBaseResponeModel } from "../../../models/response/base-response";
import {
  eCrmHocSinhActionTypeIds,
  ICrmHocSinhActionTypes,
} from "../../action-types/crm-hocsinh/ICrmHocSinhActionTypes";
import { actions } from "../../actions/actionsWrapper";

// Sagas cho học sinh
export function* crmHocSinhSaga(): any {
  yield takeLatest(eCrmHocSinhActionTypeIds.LOAD_START, loadWorker);
  // yield takeLatest(eCrmHocSinhActionTypeIds.UPDATE_ADVISOR_START, updateAdvisorWorker);
  yield takeLatest(eCrmHocSinhActionTypeIds.SEARCH_START, searchWorker);
  yield takeLatest(eCrmHocSinhActionTypeIds.GET_BY_ID_START, getByIdWorker);
}

// Worker để tải danh sách học sinh
function* loadWorker(action: ICrmHocSinhActionTypes): any {
  try {
    const payload: IHocSinhSelectRequest =
      action.payload as IHocSinhSelectRequest;
    const res: IBaseResponeModel = yield call(
      apiWrapper.crmHocSinh.select,
      payload
    ); // Gọi API với request
    if (res.is_success) {
      yield put(actions.crmHocSinh.LOAD_SUCCESS(res.data));
    } else {
      yield put(actions.crmHocSinh.LOAD_ERROR(res.message ?? "Error")); // Dispatch action LOAD_ERROR
    }
  } catch (error) {
    // Xử lý lỗi nếu cần
    yield put(actions.crmHocSinh.LOAD_ERROR("Có lỗi xảy ra!")); // Dispatch action LOAD_ERROR
  }
}

// // Worker để cập nhật thông tin cố vấn cho học sinh
// function* updateAdvisorWorker(action: any): any {
//     const res: IBaseResponeModel = yield call(apiWrapper.hocSinh.updateAdvisor, action.payload);
//     if (res.is_success) {
//         yield put(actions.crmHocSinh.UPDATE_ADVISOR_SUCCESS());
//         yield put(actions.crmHocSinh.()); // Tải lại danh sách sau khi cập nhật
//     } else {
//         yield put(actions.hocSinh.LOAD_ERROR(res.message ?? "Error"));
//     }
// }

// Worker để tìm kiếm học sinh
function* searchWorker(action: any): any {
  const { dm_truong_id, key } = action.payload;
  const res: IBaseResponeModel = yield call(
    apiWrapper.crmHocSinh.search,
    dm_truong_id,
    key
  );
  if (res.is_success) {
    yield put(actions.crmHocSinh.LOAD_SUCCESS(res.data));
  } else {
    yield put(actions.crmHocSinh.LOAD_ERROR(res.message ?? "Error"));
  }
}

// Worker để lấy thông tin chi tiết của học sinh theo ID
function* getByIdWorker(action: any): any {
  const { id, namHoc } = action.payload;
  
  const res: IBaseResponeModel = yield call(
    apiWrapper.crmHocSinh.getById,
    id,
    namHoc
  );
  if (res.is_success) {
    yield put(actions.crmHocSinh.GET_BY_ID_SUCCESS(res.data));
  } else {
    yield put(actions.crmHocSinh.LOAD_ERROR(res.message ?? "Error"));
  }
}
